export default "__VITE_ASSET__BXuAR2Ge__";